<script>
export default {
    name: "pay",
    data() {
        return {};
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="pay"></div>
</template>

<style scoped lang="scss">
.pay{
    
}
</style>